// require styles
import "swiper/dist/css/swiper.min.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
import { DashboardService } from "@/services";
export default {
  name: "dashboard-banner-card",
  components: { swiper, swiperSlide },
  props: [],
  data() {
    return {
      bannersData: null,
      dashboardBannerLoader: true,
        swiperOption: {
          direction: "horizontal",
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 16,
          setWrapperSize: 380,
          autoplay: {
            delay: 4000
          },
          // Responsive breakpoints
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 1,
              spaceBetween: 0
            },
            // when window width is >= 600px
            600: {
              slidesPerView: 1,
              spaceBetween: 0
            },
            800: {
              slidesPerView: 2,
              spaceBetween: 16
            },
            // when window width is >= 960px
            960: {
              slidesPerView: 3,
              spaceBetween: 16
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 16
            }
          },
          lazy: true,
          // navigation: {
          //   nextEl: ".swiper-button-next",
          //   prevEl: ".swiper-button-prev",
          //   disabledClass: "custom"
          // },
          pagination: {
            el: ".banner-slider-pagination",
            clickable: true
          }
        }
    };
  },
  computed: {},
  mounted() {
    this.getBannerData();
  },
  methods: {
    getBannerData() {
      DashboardService.getBanner("desktop_user_dashboard")
        .then(response => {
          this.bannersData = response.data.data;
        })
        .finally(() => {
          this.dashboardBannerLoader = false;
        });
    }
  }
};
